import { Component } from '@angular/core';

@Component({
    selector: 'ai-dialog-content',
    standalone: true,
    templateUrl: './dialog-content.component.html',
    imports: [],
})
export class DialogContent {}
